import type { HTMLAttributes } from 'react';
import type { FontSize } from '../tokens/tokens';
import styles from './Text.module.css';

export type TextTone =
  | 'default'
  | 'muted'
  | 'subtle'
  | 'accent'
  | 'danger'
  | 'success'
  | 'warning'
  | 'info';
export type TextWeight = 'regular' | 'medium' | 'semibold' | 'bold';

export interface TextProps extends HTMLAttributes<HTMLElement> {
  as?: 'p' | 'span' | 'div' | 'strong' | 'small' | 'label';
  size?: Extract<FontSize, '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'>;
  tone?: TextTone;
  weight?: TextWeight;
  /** Tabular digits for numbers in columns. */
  numeric?: boolean;
  /** Cuts off overflowing text with an ellipsis. */
  truncate?: boolean;
  /** Small caps label style (uppercase, wide tracking). */
  eyebrow?: boolean;
  align?: 'start' | 'center' | 'end';
}

export function Text({
  as: Element = 'p',
  size = 'md',
  tone = 'default',
  weight = 'regular',
  numeric = false,
  truncate = false,
  eyebrow = false,
  align,
  className,
  ...rest
}: TextProps) {
  const classes = [
    styles.text,
    styles[`size-${size}`],
    styles[`tone-${tone}`],
    styles[`weight-${weight}`],
    numeric && styles.numeric,
    truncate && styles.truncate,
    eyebrow && styles.eyebrow,
    align && styles[`align-${align}`],
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <Element className={classes} {...rest} />;
}
